import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useApplicationContext } from 'shared/utils/applicationContext';

import { RANDOM_MACRO, RANDOM_MACRO_MAX, RANDOM_MACRO_MIN } from './constants';
import { trackDailyrentBannerClick, trackDailyrentBannerShow, trackDailyrentBannerWeboramaShow } from './tracking';
import { getRandomInRange } from '../../../utils/getRandomInRange';
import { DailyrentBanner } from '../../components/DailyrentBanner';

function handleBannerShow() {
  trackDailyrentBannerShow();
  trackDailyrentBannerWeboramaShow();
}

// CD-278800 Баннер посуточной аренды сейчас выключен (флаг DailyRent.ListingDesktopBanner.Enabled)
export function DailyrentBannerContainer() {
  const { config } = useApplicationContext();
  const configUrl = config.get<string>('DailyRent.ListingDesktopBanner.Url') || 'https://www.cian.ru/posutochno/';
  const [random, setRandom] = React.useState(0);

  // Случайное число подставляем после гидрации, чтобы разметка сервера и клиента совпадала
  React.useEffect(() => {
    setRandom(getRandomInRange(RANDOM_MACRO_MIN, RANDOM_MACRO_MAX));
  }, []);

  const bannerUrl = configUrl.replace(RANDOM_MACRO, String(random));

  return (
    <ActionAfterViewObserver callback={handleBannerShow} percentVisible={0.8} triggerOnce>
      <DailyrentBanner url={bannerUrl} onClick={trackDailyrentBannerClick} />
    </ActionAfterViewObserver>
  );
}
